<template>
  <div v-if="mode=='info'">
    {{model[prop]}}
  </div>
  <div v-else-if="mode=='form'">
    <input v-model="model[prop]" type="number" @keyup.enter="onEnterKey">
  </div>
</template>

<script>
export default {
  props: ['mode', 'model', 'prop'],
  methods: {
    onEnterKey (event) {
      this.$store.dispatch('submitInfobit')
    }
  }
}
</script>



// WEBPACK FOOTER //
// number-field.vue?6c7519de